// extracted by mini-css-extract-plugin
export default {"title_block":"pages_title_block__jtkeQ","date":"pages_date__q4+et","subtitle":"pages_subtitle__iYAP6","list_link":"pages_list_link__gQebV"};